import Button from '@oneflare/flarekit/lib/components/Button';
import { useState, memo } from 'react';

import {
  HelpCenterSearchStyled,
  HelpCenterSearchWrapperStyled,
  HelpCenterSearchTitleStyled,
  InputStyled,
  LabelStyled
} from './styled/HelpCenterSearch';

const HelpCenterSearch = () => {
  const [inputValue, setInputValue] = useState('');
  const handleHelpSearch = () => {
    window.location.href = `https://help.oneflare.com.au${inputValue && `/hc/en-us/search?utf8=%E2%9C%93&query=${inputValue}`}`;
  };
  return (
    <HelpCenterSearchStyled>
      <HelpCenterSearchWrapperStyled>
        <HelpCenterSearchTitleStyled>Help centre</HelpCenterSearchTitleStyled>
        <LabelStyled>Search our knowledge base</LabelStyled>
        <InputStyled
          id="help-center"
          placeholder="Profile, Quotes, Plans etc..."
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
        />
        <Button label="Search" kind="primary-lg" onClick={() => handleHelpSearch()} />
      </HelpCenterSearchWrapperStyled>
    </HelpCenterSearchStyled>
  );
};

export default memo(HelpCenterSearch);
